import React, { useState } from "react";
import Analytics_ from '../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Analytics_&_Monitoring.svg'
import APIs_ from '../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/APIs_&_Integrations.svg'
import Backend from '../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Backend.svg'
import Cloud_ from '../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Cloud_&_Hosting.svg'
import Frontend from '../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Frontend.svg'
import Testing_Tools from '../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Testing_Tools.svg'
import Databases from '../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Databases.svg'
import DevOps_ from '../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/DevOps_&_CI.svg'

const CoreComponent32 = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const technologies = [
    { icon: Frontend, title: "Frontend", desc: "Swift", desc2: "Flutter", desc3: "React Native" },
    { icon: Backend, title: "Backend", desc: "Node.js", desc2: "Python", desc3: ".NET Core" },
    { icon: Databases, title: "Databases", desc: "PostgreSQL", desc2: "MongoDB", desc3: "Firebase" },
    { icon: Cloud_, title: "Cloud & Hosting", desc: "AWS", desc2: "Google Cloud", desc3: "Azure" },
    { icon: APIs_, title: "APIs & Integrations", desc: "GraphQL", desc2: "SOAP", desc3: "Twilio" },
    { icon: Testing_Tools, title: "Testing Tools", desc: "Appium", desc2: "Selenium", desc3: "Anti-Fraud System" },
    { icon: DevOps_, title: "DevOps & CI/CD", desc: "GitLab CI/CD", desc2: "Jenkins", desc3: "Docker" },
    { icon: Analytics_, title: "Analytics & Monitoring", desc: "Google Analytics", desc2: "Firebase Analytics", desc3: "Sentry" },
  ];

  return (
    <div>
      <div className="row">
        {technologies.map((val, i) => (
          <div
            className="col-lg-3 col-md-4 col-6 mb-4"
            key={i}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div
              className="border rounded-4 p-3 h-100"
              style={{
                marginBottom: 30,
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                transform: hoveredIndex === i ? "scale(1.05)" : "scale(1)",
                boxShadow: hoveredIndex === i ? "0 10px 20px rgba(0,0,0,0.2)" : "none",
              }}
            >
              <img
                src={val.icon}
                alt=""
                style={{
                  width: hoveredIndex === i ? 50 * 1.3 : 40,
                  height: hoveredIndex === i ? 50 * 1.3 : 40,
                  transition: "all 0.3s ease",
                }}
              />
              <h3
                className="h3-heading my-3 fs-5 fw-semibold"
                style={{
                  transform: hoveredIndex === i ? "scale(1.1)" : "scale(1)",
                  transition: "transform 0.3s ease",textAlign:"center"
                }}
              >
                {val.title}
              </h3>
              <ul className="h3-para" style={{ paddingLeft: 20,textAlign:"center" }}>
                <li style={{ transform: hoveredIndex === i ? "scale(1.05)" : "scale(1)", transition: "transform 0.3s ease" }}>{val.desc}</li>
                <li style={{ transform: hoveredIndex === i ? "scale(1.05)" : "scale(1)", transition: "transform 0.3s ease" }}>{val.desc2}</li>
                <li style={{ transform: hoveredIndex === i ? "scale(1.05)" : "scale(1)", transition: "transform 0.3s ease" }}>{val.desc3}</li>
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreComponent32;
